import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraFormField, SpecraInlineBanner, SpecraInput, SpecraOverlayDialog, SpecraTextarea } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { RegistryEntityPicker } from '../../../components/SharedRecord/RegistryEntityPicker';
import { useSetLandscapeSeat, useUpsertSeat } from '../hooks/useLandscapeSeats';
export function SeatDialog({ landscapeId, seat, onClose }) {
    const [name, setName] = useState(seat?.name ?? '');
    const [description, setDescription] = useState(seat?.description ?? '');
    const [customerOrgId, setCustomer] = useState(seat?.customerOrgId ?? '');
    const [vehicleId, setVehicle] = useState(seat?.vehicleId ?? '');
    const [order, setOrder] = useState(String(seat?.sortOrder ?? 0));
    const [created, setCreated] = useState();
    const [error, setError] = useState('');
    const save = useUpsertSeat();
    const membership = useSetLandscapeSeat();
    const submit = async ()=>{
        if (!name.trim()) {
            setError('Name is required.');
            return;
        }
        const sortOrder = Number(order);
        if (!Number.isInteger(sortOrder) || sortOrder < -2147483648 || sortOrder > 2147483647) {
            setError('Sort order must be a whole number within the supported range.');
            return;
        }
        try {
            const saved = await save.mutateAsync({
                seat: {
                    id: seat?.id || created?.id,
                    name: name.trim(),
                    description,
                    customerOrgId,
                    vehicleId
                }
            });
            if (!saved) throw new Error('Seat was not returned.');
            setCreated(saved);
            await membership.mutateAsync({
                landscapeId,
                seatId: saved.id,
                member: true,
                sortOrder
            });
            onClose();
        } catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
    };
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        open: true,
        title: seat ? 'Edit seat' : 'Add seat',
        testId: Testids.seatAdmin.seatDialog,
        onOpenChange: (v)=>{
            if (!v) onClose();
        },
        footerProps: {
            cancelLabel: 'Cancel',
            onCancel: onClose,
            confirmLabel: 'Save seat',
            onConfirm: submit,
            loading: save.isPending || membership.isPending,
            confirmProps: {
                'data-testid': Testids.seatAdmin.save
            }
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "space-y-3",
            children: [
                error && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                    tone: "danger",
                    "data-testid": Testids.seatAdmin.error,
                    children: error
                }),
                /*#__PURE__*/ _jsx(SpecraFormField, {
                    label: "Name",
                    htmlFor: "seat-name",
                    required: true,
                    children: /*#__PURE__*/ _jsx(SpecraInput, {
                        id: "seat-name",
                        value: name,
                        onChange: (e)=>setName(e.target.value)
                    })
                }),
                /*#__PURE__*/ _jsx(SpecraFormField, {
                    label: "Description",
                    htmlFor: "seat-description",
                    children: /*#__PURE__*/ _jsx(SpecraTextarea, {
                        id: "seat-description",
                        value: description,
                        onChange: (e)=>setDescription(e.target.value)
                    })
                }),
                /*#__PURE__*/ _jsx(RegistryEntityPicker, {
                    kinds: [
                        'GOVERNMENT_ORG'
                    ],
                    createMode: "none",
                    label: "Customer",
                    value: customerOrgId,
                    selectedLabel: seat?.customerLabel,
                    onPick: (o)=>setCustomer(o.registryId)
                }),
                /*#__PURE__*/ _jsx(RegistryEntityPicker, {
                    kinds: [
                        'VEHICLE'
                    ],
                    createMode: "none",
                    label: "Vehicle",
                    value: vehicleId,
                    selectedLabel: seat?.vehicleLabel,
                    onPick: (o)=>setVehicle(o.registryId)
                }),
                seat && /*#__PURE__*/ _jsx(SpecraFormField, {
                    label: "Sort order",
                    htmlFor: "seat-order",
                    children: /*#__PURE__*/ _jsx(SpecraInput, {
                        id: "seat-order",
                        type: "number",
                        step: "1",
                        value: order,
                        onChange: (e)=>setOrder(e.target.value)
                    })
                })
            ]
        })
    });
}
